import { render, staticRenderFns } from "./ViewVideoAndChatModal.vue?vue&type=template&id=439321fc&"
import script from "./ViewVideoAndChatModal.vue?vue&type=script&lang=js&"
export * from "./ViewVideoAndChatModal.vue?vue&type=script&lang=js&"
import style0 from "./ViewVideoAndChatModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports